/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Rihard Tsybulka <rykhard.tsybulka@noogadev.com>
 */

import {
    CashBoxErrorHistoryTabAction,
    CashBoxErrorHistoryTabActionType,
} from '../../../actions/CashBoxRegistry/Tabs/CashBoxErrorHistoryTabAction';

export interface CashBoxErrorHistoryTabState {
    errorsHistoryData: any;
    isLoadingErrorsHistory: boolean;
}
const initialState: CashBoxErrorHistoryTabState = {
    errorsHistoryData: null,
    isLoadingErrorsHistory: false,
};

export function cashBoxErrorHistoryTabReducer(
    state: CashBoxErrorHistoryTabState = initialState,
    action: CashBoxErrorHistoryTabAction,
): CashBoxErrorHistoryTabState {
    switch (action.type) {
        case CashBoxErrorHistoryTabActionType.FETCH_ERRORS_HISTORY:
            return {
                ...state,
                isLoadingErrorsHistory: true,
            };
        case CashBoxErrorHistoryTabActionType.FETCH_ERRORS_HISTORY_SUCCESS:
            return {
                ...state,
                isLoadingErrorsHistory: false,
                errorsHistoryData: action.payload,
            };

        case CashBoxErrorHistoryTabActionType.FETCH_ERRORS_HISTORY_ERROR:
            return {
                ...state,
                isLoadingErrorsHistory: false,
                errorsHistoryData: action.payload,
            };
    }
    return state;
}
